import { useEffect } from 'react';
import { notification } from 'antd';
import { UserSwitchOutlined } from '@ant-design/icons';
import { useNotifications } from '../../contexts/NotificationContext';

const RetryContactNotifier: React.FC = () => {
  const { subscribe } = useNotifications();

  useEffect(() => {
    return subscribe(['retry_contact_ready'], (event) => {
      const { metadata } = event;
      const contactName = metadata?.contact_name as string | undefined;

      const description = (
        <div>
          <div>{event.message}</div>
          {contactName && (
            <div style={{ marginTop: 8, fontSize: 12, color: '#6b7280' }}>
              New contact: {contactName}
            </div>
          )}
        </div>
      );

      notification.info({
        message: event.title,
        description,
        placement: 'topRight',
        duration: 8,
        icon: <UserSwitchOutlined style={{ color: '#7c3aed' }} />,
      });
    });
  }, [subscribe]);

  return null;
};

export default RetryContactNotifier;
